import React, { useState } from "react";
import { Button, message, Popconfirm, Tooltip, Modal, Input } from "antd";

import SubscriptionServices from "../../../../services/SubscriptionServices";
import { DeleteOutlined } from "@ant-design/icons";
import { translate } from "../../../../locale";

const UnsubscribeButton = ({
  subscription_id,
  username,
  onComplete,
  disabled = false,
  has_withdrawal_request = false,
  withdrawal_request_status = null,
  withdrawal_request_date = null,
}) => {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [reason, setReason] = useState("");

  const handleUnsubscribe = async () => {
    setLoading(true);
    try {
      const res = await SubscriptionServices.unsubscribe({
        subscription: subscription_id,
        patient: username,
        reason: reason || undefined,
      });
      if (res.status >= 200 && res.status < 300) {
        setVisible(false);
        setReason("");
        onComplete && onComplete();
        message.success(
          res?.data?.message ||
            translate("El usuario ha sido dado de baja de la suscripción.")
        );
      } else {
        message.error(res.data.detail || res?.data?.message, 10);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      message.error(
        error?.data?.detail ||
          error?.data?.message ||
          translate("Ocurrió un error")
      );
      setLoading(false);
    }
  };

  const handleConfirm = () => {
    setVisible(true);
  };

  if (has_withdrawal_request) {
    const statusText =
      withdrawal_request_status === "pending"
        ? translate("Baja solicitada (pendiente)")
        : translate("Baja solicitada (procesada)");
    const tooltipText = withdrawal_request_date
      ? `${statusText}\n${translate("Fecha de solicitud")}: ${withdrawal_request_date}`
      : statusText;

    return (
      <Tooltip 
      title={tooltipText}
      color="blur"
      >
        <Button
          type="text"
          icon={<DeleteOutlined />}
          size="small"
          className="border-0"
          disabled
        />
      </Tooltip>
    );
  }

  if (disabled)
    return (
      <Tooltip
        title={translate(
          "La suscripción está vencida.\nNo se puede dar de baja"
        )}
        color="blur"
      >
        <Button
          type="text"
          icon={<DeleteOutlined />}
          size="small"
          className="border-0"
          disabled
        />
      </Tooltip>
    );

  return (
    <>
      <Popconfirm
        title={translate(
          "¿Estás seguro de quitar al paciente de la suscripción?"
        )}
        okText={translate("Si")}
        cancelText={translate("No")}
        onConfirm={handleConfirm}
      >
        <Tooltip title={translate("Dar de baja")} color="blur">
          <Button
            type="text"
            icon={<DeleteOutlined />}
            size="small"
            className="border-0"
          />
        </Tooltip>
      </Popconfirm>
      <Modal
        title={translate("Motivo de la baja (opcional)")}
        open={visible}
        onCancel={() => {
          if (!loading) {
            setVisible(false);
            setReason("");
          }
        }}
        okText={translate("Guardar")}
        cancelText={translate("Cancelar")}
        onOk={handleUnsubscribe}
        confirmLoading={loading}
        destroyOnClose
      >
        <Input.TextArea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder={translate("Agrega un motivo (opcional)")}
          rows={4}
          disabled={loading}
        />
      </Modal>
    </>
  );
};

export default UnsubscribeButton;
